module.exports = __webpack_public_path__ + "static/img/2022-02.2610291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/publication/2022-02.png
// module id = r8u6
// module chunks = 6